var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Dashboard"},[_c('div',[_c('LastMeasure')],1),_vm._l((_vm.datas),function(data){return _c('div',{key:data.id},[_c('Panel',{attrs:{"data":data,"mode":_vm.mode}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }